import { Box, Link as MuiLink, Typography } from '@material-ui/core'
import type { GetStaticProps } from 'next'
import Link from 'next/link'
import { getFirestoreLadders } from '../api/server'
import Layout from '../components/Layout'
import Meta from '../components/Meta'
import { getFullUrl } from '../utils'
import { getLadderUrl } from '../utils/player'
import { pages } from '../config/main.json'

interface Props {
  ladders: { id: string; title: string }[]
}

const SitemapPage = ({ ladders }: Props) => {
  return (
    <Layout maxWidth="lg">
      <Meta title="Sitemap" url={getFullUrl('/sitemap')} />

      <Box mt={6}>
        <Typography component="h1" variant="h3">
          Sitemap
        </Typography>
      </Box>

      <ul>
        {pages.map(({ href, title }) => (
          <li key={href}>
            <Link href={href} passHref>
              <MuiLink color="secondary">{title}</MuiLink>
            </Link>
          </li>
        ))}
      </ul>

      <Box mt={3}>
        <Typography component="h2" variant="h4">
          Published Ladders
        </Typography>
      </Box>

      <ul>
        {ladders.map((ladder) => (
          <li key={ladder.id}>
            <Link href={getLadderUrl(ladder)} passHref>
              <MuiLink color="secondary">{ladder.title}</MuiLink>
            </Link>
          </li>
        ))}
      </ul>
    </Layout>
  )
}

export default SitemapPage

const ONE_HOUR = 60 * 60

export const getStaticProps: GetStaticProps = async () => {
  const firestoreLadders = await getFirestoreLadders()

  return {
    props: {
      ladders: firestoreLadders.map(({ id, title }) => ({ id, title })),
    },
    revalidate: ONE_HOUR,
  }
}
